'use strict';

angular.module('invitations')
    .controller('InvitationsTableController', ['InvitationsManager', function(InvitationsManager) {
        var vm = this;

        vm.ready = false;
        vm.invitations = [];

        vm.$onInit = function() {
            return InvitationsManager.init()
                .then(function() {
                    vm.invitations = InvitationsManager.getUserInvitations();
                    vm.ready = true;
                });
        };
    }]);
